export default {
    nav: {
        manageRestaurant: '管理餐廳',
        signOut: '登出',
        language: '語言',
        english: '英文',
        chinese: '簡體中文',
        traditionalChinese: '繁體中文'
    },
    login: {
        signInToYourAccount: '登入您的帳戶',
        enterYourEmail: '請輸入您的電子郵件',
        accountEmail: '帳號電子郵件',
        password: '密碼',
        forgotPassword: '忘記密碼？',
        signIn: '登入',
        invalidCredentials: '無效的電子郵件或密碼',
        pleaseEnterBothEmailAndPassword: '請輸入您的電子郵件和密碼。',
        errorAccountIncomplete: '帳號設置不完整。請聯繫支持。',
        errorRoleNotSet: '帳號角色未設置。請聯繫支持。',
        errorGeneric: '帳號錯誤，請聯繫我們。',
        errorMissingCredentials: '請輸入您的電子郵件和密碼。',
        forgotPasswordDescription:
            '請在下方輸入您的電子郵件，我們將會發送一封電子郵件給您以重置您的密碼。',
        resetPasswordEmailSent: '重置密碼電子郵件已發送。',
        backToLogin: '返回登入',
        sendResetPasswordEmail: '發送重置密碼電子郵件'
    },
    common: {
        loading: '載入中...',
        error: '錯誤',
        success: '成功',
        save: '儲存',
        cancel: '取消',
        edit: '編輯',
        delete: '刪除',
        reset: '重設',
        confirm: '確認',
        select: '選擇',
        back: '返回',
        title: '標題',
        subTitle: '副標題',
        changeBackgroundImage: '更改背景圖片',
        uploadYourImage: '上傳您的圖片',
        description: '描述',
        updateSuccessful: '更新成功！',
        changesWillTakeEffectOnYourWebsiteIn15Minutes: '更改將於15分鐘內在您的網站生效。',
        deleteFailed: '刪除失敗',
        couldNotDeleteGalleryFiles: '無法刪除圖庫檔案，請再試一次。',
        updateFailed: '更新失敗，請稍後再試。',
        areYouSureYouWantToDelete: '你確定要刪除嗎？',
        confirmation: '確認',
        addSection: '新增版塊',
        selectSectionType: '請選擇版塊類型'
    },
    areaTitle: {
        websiteAreaTitle: '網站區塊',
        webBasicInfoTitle: '網站基本資料',
        headerAreaTitle: '頁首區域',
        bodyAreaTitle: '主體區域',
        footerAreaTitle: '頁尾區域',
        mobileAppAreaTitle: '手機應用程式區域',
        debugAreaTitle: '除錯資訊'
    },
    webBasicInfo: {
        webDomainSection: {
            title: '🔗 網站域名',
            accessibleAt: '您的餐廳網站可透過以下域名存取：',
            noDomain: '此網站尚未設定域名。'
        },
        websiteThemeSection: {
            title: '🎨 網站主題',
            selectTheme: '請選擇主題',
            fullWidth: '全寬',
            narrow: '窄寬',
            desktopView: '桌面檢視',
            mobileView: '流動檢視',
            save: '儲存'
        }
    },
    sectionType: {
        topNews: '📣 頂部新聞',
        text: '📝 文字',
        news: '📢 新聞',
        socialNetworks: '🌍 社交網絡',
        reviewPlatforms: '⭐ 評分平台',
        gallery: '🖼️ 圖庫',
        customCode: '💻 自訂程式碼',
        staging: '🖼️ 主視覺區',
        openingHours: '⏰ 營業時間',
        map: '🗺️ 地圖',
        specialOffers: '🎉 特別優惠',
        mobileOrderingApp: '📱 應用程式下載',
        orderAppNews: '📱 提示/公告'
    },
    orderAppNews: {
        helperText: '提醒顧客重要資訊，例如: 過敏原提示或通告。',
        missingMessage: '目前沒有過敏原提示資料。'
    },
    section: {
        staging: {
            systemTitle: '系統產生標題（與餐廳設定一致，SEO 友善）',
            systemSubTitle: '系統產生副標題（與餐廳設定一致，SEO 友善）'
        },
        fixed: {
            title: '固定區域',
            contentSource: '內容來源',
            contentSourceHint:
                '系統生成：依餐廳設定自動生成（SEO 友好）；自訂內容可編輯標題與描述。',
            contentSourceSystem: '系統生成',
            contentSourceCustom: '自訂內容',
            promotionsDisplayPolicy: '推廣顯示政策',
            promotionsDisplayPolicyDescription:
                '我們會顯示所有顧客適用的推廣活動。有條件限制的推廣（例如新客、優惠碼或獎賞計劃）不會顯示。',
            needToMakeChanges: '需要修改？',
            needToUpdateDeliveryZones: '要更新配送區域資訊？',
            modifyInRestaurantAdminPanel: '請於餐廳管理後台修改',
            thisSectionIsNotEditable: '此區域不可編輯，但可透過拖曳調整顯示次序。'
        },
        gallery: {
            images: '圖片',
            imageTitle: '圖片標題',
            noImagesYet: '尚無圖片',
            deleteFailed: '刪除失敗',
            deleteFailedDescription: '無法刪除圖片，請再試一次。',
            galleryTitle: '圖庫標題',
            addImage: '新增圖片',
            uploadGalleryImage: '上傳圖庫圖片'
        },
        reviewPlatforms: {
            pleaseEnterAValidPlatformURL: '請輸入有效的 {platform} 網址'
        },
        socialNetworks: {
            pleaseEnterAValidPlatformURL: '請輸入有效的 {platform} 網址'
        }
    },
    uploadImgDialog: {
        imageDimensionTooSmall: '圖片寬度過小，最小寬度需為 {minQualityWidth} 像素',
        imageDimensionTooSmallHeight: '圖片高度過小，最小高度需為 {minQualityHeight} 像素',
        imageSizeTooBig: '圖片檔案過大，最大容量為 {maxSizeMB} MB',
        imageTooSmallHardReject:
            '圖片解析度過低，至少需 {need}（或短邊 ≥ {minShortEdge} 像素），目前為 {got}。',
        imageSmallWillUpscale:
            '此圖片小於建議尺寸 {recommend}，繼續將放大，可能影響清晰度（目前 {got}）。',
        zoomInstructionsPart1: '縮放：使用',
        zoomInstructionsPart2: '按鈕或滑鼠滾輪',
        moveInstructions: '移動：點擊並拖曳圖片調整位置',
        cropAreaInstructions: '藍色邊框顯示裁剪範圍',
        cropAndSelectInstructions: '確認後按「裁剪並選擇」',
        howToAdjustYourImage: '調整圖片指引：',
        chooseFile: '選擇檔案',
        cropAndSelect: '裁剪並選擇',
        uploading: '上傳中',
        selectAnImageFromYourDevice: '從裝置選擇圖片',
        supportedFormats: '支援格式',
        maxSize: '最大容量',
        clickToBrowseFiles: '按此瀏覽檔案',
        invalidFileType: '檔案格式錯誤，請上傳 {acceptedExtensions} 檔案。',
        couldNotLoadImage: '圖片讀取失敗，請換一張試試。',
        transparentNote: '未填滿的區域匯出時將維持透明背景。',
        dragAndDropHint: '可拖放、貼上或使用下方按鈕上傳圖片。',
        assetInfo: '素材資訊',
        replaceImage: '替換圖片',
        validationSummary: '檢查結果',
        fitTip: '點擊重設即可回到置中的最佳視圖。',
        sourceDimensions: '原始尺寸：{size}',
        fileSizeLabel: '檔案大小：{size}',
        exportDimensions: '匯出尺寸：{size}',
        recommendedSize: '建議匯出尺寸：{size}',
        footerHint: '匯出尺寸 {size}，未覆蓋區域保持透明。',
        uploadFailed: '上傳失敗，請再試一次。'
    },
    drag: {
        dropHere: '放開後會移到這裡',
        dropAtEnd: '拖放到列表最後'
    },
    footer: {
        copyright: '© {year} Whatfood 合作夥伴平台。版權所有。'
    }
}
